<template>
  <v-card
    class="overflow-hidden"
    color="tiendasimilia"
    dark
  >
    
    <v-card-text>
      <v-text-field v-on:keyup.enter="buscar"
          v-model="filtrolibrebuscarsustancia"
          clearable
          color="white"
          label="Filtro libre"
        ></v-text-field>
    </v-card-text >
    <v-divider></v-divider>
    <v-card-actions >
      <v-spacer></v-spacer>
        <v-btn @click="buscar" class="text-center justify-center"
          color="similiaverde darken-5"
          block
        >
        Buscar sustancia
      </v-btn>
    </v-card-actions>
    <v-divider></v-divider>
    <div v-if="barraEscritorio">
      <v-container px-6 mt-5  v-if="resultadosvisibles">
          <div id="resultados" >
            <v-data-table
            no-data-text="No se han encontrado resultados. Consulte con nuestro laboratorio."
            :headers="headerssustancia"
            :items="resultados"
            :items-per-page="9999"
            hide-default-footer
            sort-by="nombre"
            class="elevation-5 similiaverde"
          >
            <template v-slot:top  >
              <v-toolbar
                flat
                color="similiaverde"
              >                 
              <v-toolbar-title class="flex text-center tiendasimilia" color="black"><B>SUSTANCIAS</B></v-toolbar-title>
                <v-dialog
                  v-model="dialog"
                  max-width="500px"
                  color="tiendasimilia"
                >
                  <v-card  class="flexcard" loading="red" >
                    <div class="text-center">         
                    <v-toolbar color="similiaazul" dark > 
                      <v-toolbar-title   class="flex text-xs-center">
                        <v-icon>mdi-clipboard-text</v-icon>
                        {{ nro }}  {{nombreformula}}
                      </v-toolbar-title>

                    </v-toolbar>
                    </div>
                    <v-container>
                        <v-col>  

                            <v-alert  border="left" v-if="formula!=''" color="similiaazul" outlined prominent text type="info">
                              {{ formula }}
                            </v-alert>
                            <v-layout row wrap>
                              <v-col>      
                            <v-text-field v-model="forma" v-if="forma!=''"
                                          readonly
                                          label="Forma"
                                          outlined
                                          color="similiaazul"
                            ></v-text-field>
                            </v-col> 
                            <v-col>
                            <v-text-field v-model="posologia" v-if="posologia!=''"
                                          readonly
                                          label="Posología"
                                          outlined
                                          color="similiaazul"
                            ></v-text-field>
                            </v-col>
                            </v-layout>
                            
                            <v-text-field v-model="terapia" v-if="terapia!=''"
                                          readonly
                                          label="Terapias"
                                          outlined
                                          color="similiaazul"
                            ></v-text-field>

                          <!-- <v-alert border="left" color="similiaazul" outlined prominent text type="info">
                          Su aroma cítrico y refrescante es ideal para sentirlo al comenzar el día o cuando aparece el cansancio, los bloqueos energéticos o nos sentimos vulnerables. Brinda mucha energía, calidez, creatividad y eleva nuestro poder vibratorio.  
                          </v-alert> -->
                          <v-alert 
                                  border="top" v-if="patologia!=''"
                                  colored-border
                                  type="info"
                                  elevation="2"
                          > {{ patologia }}
                          </v-alert>
                          
                            <v-alert  border="left" v-if="contraindicacion!=''"
                                colored-border
                                type="error"
                                elevation="2"
                                prominent
                            > Contraindicaciones:  <br>
                            {{ contraindicacion }}
                            </v-alert>
                      
                        <br>
                        <v-btn 
                        block
                        text
                        color="similiaazul"
                        elevation="5"
                        rounded
                        outlined
                        dark
                        @click="dialog = false"
                        >
                        CERRAR<v-icon>mdi-check</v-icon>
                        </v-btn>
                        <br>
                    </v-col>
                    </v-container >
                  </v-card>

                </v-dialog>
              
              </v-toolbar>
                
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon 
                small
                centered
                class="mr-2"
                @click="infoItem(item)"
              >
                mdi-information-variant
              </v-icon>
              
            </template>
            <template v-slot:no-data>
              
            </template>
              
            </v-data-table>
          </div>
      </v-container>
    </div>
    <div v-else>
      <v-container px-2 mt-1 id="panelsustancias" v-if="resultadosvisibles">
          <div id="sustanciasresultados" >
              <v-data-table
                :headers="sustanciaheadersCelu"
                :items="resultados"
                :items-per-page="9999"
                no-data-text="No se encontraron sustancias. Consulte con nuestros laboratorios."
                sort-by="nombre"
                class="elevation-5 similiaverde"
                hide-default-header
                hide-default-footer
                mobile-breakpoint=""
              >
              <template v-slot:top>
                <v-toolbar flat color="verdeclarito"> 
                <v-toolbar-title class="flex text-center tiendasimilia" color="black"><B>SUSTANCIAS</B></v-toolbar-title>
                  <!-- inicio tarjetasustancia de sustancias-->
                  <v-dialog
                      v-model="dialog"
                      max-width="500px"
                      color="tiendasimilia"
                    >
                      <v-card  class="flexcard"  >
                        <div class="text-center">         
                          <v-toolbar color="similiaverde" dark > 
                            <v-toolbar-title class="flex text-start">{{referencias}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn color="white" @click="dialog = false" icon>
                              <v-icon>mdi-close</v-icon>
                            </v-btn>                    
                          </v-toolbar>
                        </div>
                        <v-container>
                          <h5 class="text-center"><br/>Para mas información contacte a nuestros laboratorios.<br/></h5> 
                        <v-divider class="pb-10"></v-divider>   
                        </v-container >
                      </v-card>
                  </v-dialog>
                  <!-- fin tarjetasustancia de sustancias-->
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn elevation="3" class="mt-2" icon x-small center color="tiendasimilia" @click="infoItem(item)">
                  <v-icon>mdi-information-variant</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.nombre`]="{ item }">
                <div align="left">
                  <span><B>{{item.nombre.trim()}}</B><br/><I>{{item.referencias}}<br/>{{item.sinonimias}}</I></span>
                </div>
              </template>
            </v-data-table>
          </div>
      </v-container>
    </div> 
    <v-snackbar
      v-model="hasSaved"
      :timeout="1000"
      absolute
      centered
    >
      Buscando...
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from "axios";
import VueScreenSize from 'vue-screen-size';
  export default {
    mixins: [VueScreenSize.VueScreenSizeMixin],
    data () {
      return {
        barraEscritorio:true,
        terapiabuscar:'',
        ramabuscar:'',
        patologiabuscar:'',
        sustanciabuscar:'',
        filtrolibrebuscarsustancia: '',
        hasSaved: false,
        model: null,
        terapias: [],
        ramas: [],
        patologias: [],
        sustancias: [],
        selectedterapia:{idterapia:0, terapia: ''},
        selectedrama:{idrama:0, rama: ''},
        selectedpatologia:{idpatologia:0, patologia: ''},
        selectedsustancia:{idsustancia:0, nombre: ''},
        dialog: false,
        nombreformula: '',
        nro: '',
        contraindicacion: '',
        forma: '',
        cantidad: '',
        posologia: '',
        formula: '',
        terapia: '',
        subterapia: '',
        rama: '',
        patologia: '',
        tipo: '',
        nombre: '',
        parte: '',
        chakra: '',
        concentracion: '',
        headerssustancia: [
        {text: 'Nombre', align: 'start', value: 'nombre',width: '30%' },
        {text: 'Referencia / Sinonimias', value: 'referencias' ,width: '30%' },
        {text: '', value: 'sinonimias', width: '40%', sortable: false },
        ],
        sustanciaheadersCelu: [
        { text: '+info', value: 'actions', align: 'left', sortable: false, width: '15%' },
        { text: 'Nombre', align: 'left', value: 'nombre', width: '85%' },
        ],
      resultados: [],
      editedIndex: -1,
      editedItem: {
        terapia: '',
        subterapia: '',
        rama: '',
        patologia: '',
        tipo: '',
        nombreformula: '',
        nro: '',
        contraindicacion: '',
        forma: '',
        cantidad: '',
        posologia: '',
        formula: '',
      },
      defaultItem: {
        terapia: '',
        subterapia: '',
        rama: '',
        patologia: '',
        tipo: '',
        nombreformula: '',
        nro: '',
        contraindicacion: '',
        forma: '',
        cantidad: '',
        posologia: '',
        formula: '',
      },
      resultadosvisibles: false,
        
      }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

     watch: {
      dialog (val) {
        val || this.close()
      },
      
    },

    created () {
      this.initialize();
    },

    methods: {

      initialize(){
        if ( this.$vssWidth > 600 ) {
          this.barraEscritorio = true;
        } else {
          this.barraEscritorio = false;
        }
      },

      close () {
          this.dialog = false;
      },

      infoItem (item) {
        this.nro=item.nro;
        this.forma=item.forma;
        this.formula=item.formula;
        this.posologia=item.posologia;
        this.patologia=item.patologia;
        this.contraindicacion=item.contraindicacion;
        this.terapia=item.terapia;
        this.nombreformula=item.nombreformula;
        this.dialog = true;
      },

      save () {
        this.isEditing = !this.isEditing
        this.hasSaved = true
      },

      buscar: function (){
        
        this.resultadosvisibles=true;
        let me=this;

        if ( !this.filtrolibrebuscarsustancia ) {
          this.filtrolibrebuscarsustancia='';
        }

        me.resultados = [];
        axios.post('api/Sustancias/Buscar', {filtrolibre: this.filtrolibrebuscarsustancia.trim() }).then(function(response){
            me.resultados=response.data;
        }).catch(function(error){
            console.log(error);
        });
      },

    },
  }
</script>